import { fetch, buildQueryString } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export const getProducts = (userId, opts = {}) => (
  fetch(
    getUrl(`/products${buildQueryString(opts)}`),
    {
      headers: { 'Tgb-Owner': userId },
    },
  )
);

export const saveProduct = (userId, payload) => (
  fetch(getUrl('/products'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Tgb-Owner': userId,
    },
    body: JSON.stringify(payload),
  })
);

export const deleteProduct = (userId, productId) => (
  fetch(getUrl(`/products/${productId}`), {
    method: 'DELETE',
    headers: { 'Tgb-Owner': userId },
  })
);

export const saveProductToCollection = (userId, collectionId, payload) => (
  fetch(getUrl(`/collections/${collectionId}/products`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Tgb-Owner': userId,
    },
    body: JSON.stringify(payload),
  })
);

export const getCollections = (userId, opts = {}) => (
  fetch(
    getUrl(`/collections${buildQueryString(opts)}`),
    {
      headers: { 'Tgb-Owner': userId },
    },
  )
);

export const getSettingsByAffiliate = (userId, affiliate) => (
  fetch(getUrl(`/affiliates/config/${affiliate}`), {
    headers: { 'Tgb-Owner': userId },
  })
);
